import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../../../hooks'
import {
  getIsMockMatchJobDone,
  getMockMatchReevaluationJob,
} from '../../../../../../../RentalPortalListing'

import { MATCH_REEVALUATION_POLL_INTERVAL } from './useMatchRulesReevaluation.constants'

export function useMatchRulesReevaluation({ onFinished }) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const timeoutRef = useRef(null)

  useEffect(() => () => clearTimeout(timeoutRef.current), [])

  function pollJob({ applicants, jobId }) {
    return getMockMatchReevaluationJob(jobId).then(job => {
      if (getIsMockMatchJobDone(job)) {
        handleAddSuccessNotification({
          title: t('RentalPortal.MatchRulesReevaluatedKey', {
            count: applicants,
          }),
        })

        return onFinished()
      }

      timeoutRef.current = setTimeout(
        () => pollJob({ applicants, jobId }),
        MATCH_REEVALUATION_POLL_INTERVAL
      )

      return null
    })
  }

  function handleStartReevaluation({ applicants, jobId }) {
    handleAddSuccessNotification({
      title: t('RentalPortal.MatchRulesReevaluatingKey', { count: applicants }),
    })

    return pollJob({ applicants, jobId })
  }

  return { handleStartReevaluation }
}
